/**
 * Subscription plan tiers, lowest to highest.
 *
 * Start is the implicit tier of every account with no entitling subscription - it is never
 * bought, so it has no Stripe price. Custom ("Na mieru") is assigned internally rather than
 * sold self-serve; see AccountEntity.manualPlanTier.
 */
export enum PlanTier {
  Start = 'start', // Štart
  Growth = 'growth', // Rast
  Pro = 'pro', // Profi
  Custom = 'custom', // Na mieru
}

/** Ordered lowest -> highest. Index in this array is the tier's rank. */
export const PLAN_TIER_ORDER: PlanTier[] = [PlanTier.Start, PlanTier.Growth, PlanTier.Pro, PlanTier.Custom]

export const planRank = (tier: PlanTier): number => PLAN_TIER_ORDER.indexOf(tier)

export type PlanTierLabelKey = `plan.tier.${PlanTier}`

/** Translation keys. Resolve them in the presentation layer - no locale strings live here. */
export const PLAN_TIER_LABEL_KEYS: Record<PlanTier, PlanTierLabelKey> = {
  [PlanTier.Start]: 'plan.tier.start',
  [PlanTier.Growth]: 'plan.tier.growth',
  [PlanTier.Pro]: 'plan.tier.pro',
  [PlanTier.Custom]: 'plan.tier.custom',
}
